import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Estado de apertura del panel del asistente.
 *
 * El disparador vive en la navbar y el panel en AppComponent, así que el
 * estado se comparte acá en vez de pasarlo por inputs entre componentes que
 * no tienen relación de padre/hijo.
 */
@Injectable({
  providedIn: 'root'
})
export class AssistantPanelService {
  private openSubject = new BehaviorSubject<boolean>(false);

  readonly open$: Observable<boolean> = this.openSubject.asObservable();

  get isOpen(): boolean {
    return this.openSubject.value;
  }

  open(): void {
    this.openSubject.next(true);
  }

  close(): void {
    this.openSubject.next(false);
  }

  toggle(): void {
    this.openSubject.next(!this.openSubject.value);
  }
}
